<template>
  <v-snackbar
    :value="snackbar.display"
    @input="closeSnackbar"
    :color="snackbar.color"
    right
  >
    {{ snackbar.text }}
    <template v-slot:action="{ attrs }">
      <v-btn text v-bind="attrs" @click="closeSnackbar">Fermer</v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  methods: {
    ...mapActions("snackbar", ["closeSnackbar"]),
  },
  computed: {
    ...mapState({
      snackbar: (state) => state.snackbar,
    }),
  },
};
</script>